module.exports = __webpack_public_path__ + "img/approval4.bfa8db2e.png";